export default __webpack_public_path__ + "static/media/Artboard2.9907c67c.png";